import React from 'react';
import { ButtonV2, Flex, TextV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { useTranslation } from '@shared/core';
import { StationeryTemplateCategoryEnum } from '@graphql/generated';

const Container: React.FC = ({ children }) => {
  const { tq } = useTranslation('stationery');

  return (
    <Flex
      flexDirection="column"
      gap={6}
      width="100%"
      maxWidth={pxToRem(1248)}
      paddingX={6}
      paddingY={10}
      marginX="auto"
    >
      <TextV2 typographyVariant="hed2">{tq`Related Links`}</TextV2>
      <Flex
        gap={5}
        flexWrap="wrap"
      >
        {children}
      </Flex>
    </Flex>
  );
};

const Link: React.FC<{
  href: string;
  children: React.ReactNode;
}> = ({ href, children }) => {
  return (
    <ButtonV2
      size="sm"
      intent="neutral"
      variant="link"
      as="a"
      href={href}
    >
      {children}
    </ButtonV2>
  );
};

type RelatedLinksProps = Readonly<{
  category: StationeryTemplateCategoryEnum;
}>;

export const RelatedLinks: React.FC<RelatedLinksProps> = ({ category }) => {
  const { tq } = useTranslation('stationery');

  if (category === StationeryTemplateCategoryEnum.saveTheDate) {
    return (
      <Container>
        <Link href="/wedding-website">{tq`Wedding Website`}</Link>
        <Link href="/wedding-invitations">{tq`Wedding Invitations`}</Link>
        <Link href="/online-rsvp">{tq`Smart RSVP`}</Link>
        <Link href="/registry">{tq`Registry`}</Link>
      </Container>
    );
  }

  return null;
};
